import React, { useEffect } from 'react';

export const QuickShoppingList = () => {

    return <div className="QuickLoansContainer">
        <table id="tablePreview" className="table">
            <thead>
                <tr>
                    <th>Položka</th>
                    <th>Množství</th>
                    <th>Doporučená cena</th>
                    <th>*</th>
                </tr>
            </thead>
            <tbody>
                <tr>

                    <td>Mléko</td>
                    <td>6 ks</td>
                    <td>12,90 Kč</td>
                    <td><input style={{margin:0}} className="btn btn-primary btn-sm" type="button" value="Koupeno" /></td>
                </tr>
                <tr>
                    <td>Máslo</td>
                    <td>2 ks</td>
                    <td>45 Kč</td>
                    <td><input style={{margin:0}} className="btn btn-primary btn-sm" type="button" value="Koupeno" /></td>
                </tr>
                <tr>

                    <td>Pivo 11°</td>
                    <td>20 ks</td>
                    <td>10,90 Kč</td>
                    <td><input style={{margin:0}} className="btn btn-primary btn-sm" type="button" value="Koupeno" /></td>
                </tr>
            </tbody>
        </table>

    </div >
}